import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const ROLE = { admin: "Admin", manager: "Manager", coach: "Coach", lecturer: "Dozent" };

export default function CcSettingsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/cc-settings/staff").then((r) => setRows(r.data)).catch((e) => toast.error(e.message)); }, []);

  const toggle = async (u, key) => {
    const next = { cc_billing: u.cc_billing, cc_traeger: u.cc_traeger, [key]: !u[key] };
    setRows((rs) => rs.map((x) => (x.user_id === u.user_id ? { ...x, ...next } : x)));
    try { await api.put(`/cc-settings/staff/${u.user_id}`, next); toast.success(`${u.name}: gespeichert`); }
    catch (e) {
      setRows((rs) => rs.map((x) => (x.user_id === u.user_id ? u : x)));
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  if (!rows) return <div className="text-xs text-slate-400 p-4">Lädt…</div>;
  return (
    <div className="space-y-4" data-testid="cc-settings-tab">
      <p className="text-sm text-slate-500 max-w-2xl">Lege fest, welche Mitarbeiter eine Kopie (CC) erhalten. „Abrechnung“ = Rechnungsversand an Jobcenter/Agentur (zusätzlich zu den festen CC-Adressen im Billing Center). „Trägerbestätigung“ = Versand der ausgefüllten Trägerbestätigung.</p>
      <div className="border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm min-w-[560px]">
          <thead className="text-[10px] uppercase tracking-overline text-slate-500 border-b">
            <tr><th className="text-left px-4 py-2">Mitarbeiter</th><th className="text-left px-4 py-2">Rolle</th><th className="px-4 py-2">CC Abrechnung</th><th className="px-4 py-2">CC Trägerbestätigung</th></tr>
          </thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.user_id} className="border-b last:border-0" data-testid={`cc-row-${u.user_id}`}>
                <td className="px-4 py-2"><div className="font-medium text-slate-900">{u.name}</div><div className="text-xs text-slate-500">{u.email}</div></td>
                <td className="px-4 py-2 text-xs text-slate-600">{[u.role, ...(u.extra_roles || [])].filter((r, i, arr) => arr.indexOf(r) === i).map((r) => ROLE[r] || r).join(" + ")}</td>
                {["cc_billing", "cc_traeger"].map((k) => (
                  <td key={k} className="px-4 py-2 text-center">
                    <input type="checkbox" checked={u[k]} onChange={() => toggle(u, k)} className="h-4 w-4 accent-slate-900 cursor-pointer" data-testid={`cc-${k}-${u.user_id}`} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
